import { FelaCSS, FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  title: FelaCSS;
  item: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    marginBottom: spacing[6],
    maxWidthTabletSm: {
      marginLeft: spacing[4],
    },

    '& .alice-carousel__stage': {
      display: 'flex',
    },
    '& .alice-carousel__stage-item': {
      flex: '1 0 auto',
      height: 'auto',
    },
  },
  title: {
    fontDefaultSemiBold: 22,
    minHeight: 40,
    marginBottom: spacing[2],
  },
  item: {
    marginRight: spacing[4],
    height: '100%',
  },
});

export default styles;
